import React from 'react';
import Icon from 'components/lib/icons/icon';

export default function Headset(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        d="M2.59 5.677C3.06 3.035 5.305 1.032 8 1.032s4.94 2.003 5.41 4.645H13c-.552 0-1 .463-1 1.033v4.129c0 .57.448 1.032 1 1.032h.409c-.149.758-.475 1.306-.954 1.696-.546.446-1.346.736-2.456.84-.022-.834-.685-1.504-1.499-1.504-.828 0-1.5.694-1.5 1.549S7.672 16 8.5 16c.451 0 .856-.206 1.131-.531 1.44-.073 2.606-.407 3.445-1.092.75-.612 1.184-1.46 1.348-2.506H15c.552 0 1-.462 1-1.032v-4.13c0-.57-.448-1.032-1-1.032h-.576C13.943 2.462 11.25 0 8 0 4.75 0 2.057 2.462 1.576 5.677H1c-.552 0-1 .463-1 1.033v4.129c0 .57.448 1.032 1 1.032h2c.552 0 1-.462 1-1.032v-4.13c0-.57-.448-1.032-1-1.032h-.41z"
        fill="#919191"
      />
    </Icon>
  );
}
